<section class="global-message" [class.global-message--hidden]="!messages().length"
  (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="global-message__container" [style.transform]="'translateY(-' + (currentIndex() * 40) + 'px)'">
    @for (message of messages(); track $index) {
    <div class="global-message__slide">
      <span class="global-message__text" [class.line-clamp-1]="message.link?.text && message.link?.url"
        [class.line-clamp-2]="!message.link?.text || !message.link?.url">
        {{message.text}}
      </span>
      @if (message.link?.text && message.link?.url) {
      <a class="global-message__link line-clamp-1" [href]="message.link.url">
        {{message.link.text}}
      </a>
      }
    </div>
    }
  </div>
</section>